import { useEffect, useState } from 'react';

const useMediaQuery = (query: string): boolean => {
  const getInitial = () =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false;

  const [matches, setMatches] = useState<boolean>(getInitial);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Set initial in case it changed between render and effect — a one-shot
    // sync to an external browser API, which is the use case the rule allows.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMatches(mql.matches);

    // Modern API
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    // Fallback for older browsers
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
